import { Card, CardBody, Col } from "reactstrap";
import { DashedBorderTitle } from "../../../Constants/Constants";
import { DashedBorderSubData } from "../../../Data/UiKits/HelperClasses";
import { dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const DashedBorder = () => {
  return (
    <Col xl="3">
      <Card>
        <CommonCardHeader title={DashedBorderTitle} span={DashedBorderSubData}/>
        <CardBody>
          <div className="helper-common-box helper-p-wrapper">
            {dynamicNumber(3).map((item, index) => (
              <div key={index} className={`border-common-box border-s-dashed b-width-${item}`}>b-width-{item}</div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DashedBorder;
